"use client";

import { DemoReportCard } from "./DemoReportCard";

interface DemoReport {
  id: string;
  publicToken: string;
  domain: string;
  snapshot?: {
    data: {
      name?: string;
      tagline?: string;
      category?: string;
    };
  };
  property: {
    // PERSON subjects have no domain
    domain: string | null;
    companyName?: string | null;
    subjectType?: string;
    logo?: string | null;
  };
}

interface DemoReportsGridProps {
  reports: DemoReport[];
}

export function DemoReportsGrid({ reports }: DemoReportsGridProps) {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {reports.slice(0, 6).map((report) => (
        <DemoReportCard key={report.id} report={report} />
      ))}
    </div>
  );
}

